"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var errors_1 = require("../errors");

exports.authorizeSilently = function (uri, origin, timeout) {
  return new Promise(function (resolve, reject) {
    var timeoutId;
    var iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    var cleanup = function cleanup() {
      window.removeEventListener("message", onMessageHandler);

      if (iframe && iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }

      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };

    var onMessageHandler = function onMessageHandler(event) {
      if (event.origin !== origin) {
        return;
      }

      cleanup();

      if (event.data && !event.data.error) {
        var code = event.data.response.code;
        return resolve(code);
      } else {
        var error = event.data && event.data.error || new errors_1.RenewTokenError({
          message: "Invalid message received from server"
        });
        return reject(error);
      }
    };

    window.addEventListener("message", onMessageHandler);
    iframe.src = uri;
    timeoutId = setTimeout(function () {
      cleanup();
      return reject(new errors_1.RenewTokenError({
        message: "Server did not respond with authorization code, aborting."
      }));
    }, timeout);
  });
};